import { render, staticRenderFns } from "./cookiePanel.vue?vue&type=template&id=3843fb4f&scoped=true&"
import script from "./cookiePanel.vue?vue&type=script&lang=js&"
export * from "./cookiePanel.vue?vue&type=script&lang=js&"
import style0 from "./cookiePanel.vue?vue&type=style&index=0&id=3843fb4f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843fb4f",
  null
  
)

export default component.exports